import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastComponent } from './shared/toast-component/toast-component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastComponent],
  template: `
    <router-outlet/>
    <app-toast/>
  `,
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('tiaki-arc-backoffice');
}
